import React from 'react';
import { Card, CardGroup } from 'react-bootstrap';


function CreateCards({ data }) {

    let arrRa = [];
    let pAtrasado = [];
    let addPessoaAtrasado = [];
    let pCritico = [];
    let addPessoaCritico = [];
    let pModerado = [];
    let addPessoaModerado = [];
    let pTriado = [];
    let addPessoaTriado = [];

    for (let i = 0; i < data.length; i++) {
        arrRa[i] = [data[i].ra, data[i].tempo, data[i].tempo_decorrido];
    }
    let filtroDados = arrRa.filter((elem, index, arr) => arr.indexOf(elem) === index);
    let atrasado = 0;
    let critico = 0;
    let moderado = 0;
    let triado = 0;
    let totalPessoaAtrasado = "";
    let totalPessoaCritico = "";
    let totalPessoaModerado = "";
    let totalPessoaTriado = "";
    for (let i = 0; i < filtroDados.length; i++) {
        const contRa = filtroDados[i][0];
        const tempoExame = filtroDados[i][1];
        const tempoDecorrido = filtroDados[i][2];

        if (tempoDecorrido <= (tempoExame / 3)) {
            triado++;
            addPessoaTriado[i] = contRa;
        } else if (tempoDecorrido <= (tempoExame / 3 * 2)) {
            moderado++;
            addPessoaModerado[i] = contRa;
        } else if (tempoDecorrido <= tempoExame) {
            critico++;
            addPessoaCritico[i] = contRa;
        } else {
            atrasado++;
            addPessoaAtrasado[i] = contRa;
        }
        pAtrasado = addPessoaAtrasado.filter((elem, index, arr) => arr.indexOf(elem) === index);
        pCritico = addPessoaCritico.filter((elem, index, arr) => arr.indexOf(elem) === index);
        pModerado = addPessoaModerado.filter((elem, index, arr) => arr.indexOf(elem) === index);
        pTriado = addPessoaTriado.filter((elem, index, arr) => arr.indexOf(elem) === index);

    }
    totalPessoaAtrasado = pAtrasado.length;
    totalPessoaCritico = pCritico.length;
    totalPessoaModerado = pModerado.length;
    totalPessoaTriado = pTriado.length;
    //console.log("total : ", totalPessoaAtrasado, " | ", totalPessoaCritico, " | ", totalPessoaModerado, " | ", totalPessoaTriado)
    //console.log("somados: ", atrasado, " | ", critico, " | ", moderado, " | ", triado);

    return (
        <>
            <CardGroup className="mr-4 ml-4">
                <Card bg="danger" text="white" className="text-center m-4 borderCard small-box" style={{ width: '15rem' }} >
                    <Card.Body>
                        <Card.Title>ATRASADO</Card.Title>
                        <Card.Text className="sizeFont">
                            {atrasado}
                        </Card.Text>
                        <Card.Text>
                            <small >{totalPessoaAtrasado} PACIENTE(S)</small>
                        </Card.Text>
                    </Card.Body>
                </Card>
                <Card bg="warning" text="white" className="text-center m-4 borderCard" style={{ width: '15rem' }} >
                    <Card.Body>
                        <Card.Title>CRITICO</Card.Title>
                        <Card.Text className="sizeFont">
                            {critico}
                        </Card.Text>
                        <Card.Text>
                            <small >{totalPessoaCritico} PACIENTE(S)</small>
                        </Card.Text>
                    </Card.Body>
                </Card>
                <Card bg="primary" text="white" className="text-center m-4 borderCard" style={{ width: '15rem' }} >
                    <Card.Body>
                        <Card.Title>MODERADO</Card.Title>
                        <Card.Text className="sizeFont">
                            {moderado}
                        </Card.Text>
                        <Card.Text>
                            <small >{totalPessoaModerado} PACIENTE(S)</small>
                        </Card.Text>
                    </Card.Body>
                </Card>
                <Card bg="dark" text="white" className="text-center m-4 borderCard" style={{ width: '15rem' }} >
                    <Card.Body>
                        <Card.Title>TRIADO</Card.Title>
                        <Card.Text className="sizeFont">
                            {triado}
                        </Card.Text>
                        <Card.Text>
                            <small >{totalPessoaTriado} PACIENTE(S)</small>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </CardGroup>
        </>
    );
}

export default CreateCards;